import React from 'react';

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    indexOfFirstEntry: number;
    indexOfLastEntry: number;
    totalEntries: number;
}

const Pagination: React.FC<PaginationProps> = (
    {
        currentPage,
        totalPages,
        onPageChange, indexOfFirstEntry,
        indexOfLastEntry,
        totalEntries
    }) => {
    return (
        <div className="flex flex-col-reverse md:flex-row justify-between items-center mt-4 gap-2">
            <p className="text-black-accent/60">
                Showing data {indexOfFirstEntry + 1} to {indexOfLastEntry >= totalEntries ? totalEntries : indexOfLastEntry} of {totalEntries} entries
            </p>
            <div className="flex space-x-2">
                <button
                    data-testid="previous-page"
                    className={`px-3 py-1 rounded border border-primary text-primary ${currentPage === 1 ? 'disabled:cursor-not-allowed '
                         : 'bg-white hover:bg-green-600 hover:text-white'}`}
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    Prev
                </button>
                {Array.from({ length: totalPages }, (_, index) => (
                    <button
                        data-testid="current-page"
                        key={index}
                        className={`px-3 py-1 border rounded ${currentPage === index + 1 ? 'bg-green-800 text-white' : 'text-gray-600 hover:bg-green-200'}`}
                        onClick={() => onPageChange(index + 1)}
                    >
                        {index + 1}
                    </button>
                ))}
                <button
                    data-testid="next-page"
                    className={`px-3 py-1 rounded border border-primary text-primary ${currentPage === totalPages ?
                        'disabled:cursor-not-allowed' : 'border border-primary text-primary bg-white hover:bg-green-600 hover:text-white'}`}
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default Pagination;